import * as React from "react";
import type { SVGProps } from "react";

const BonusCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      d="M21.87 7.37c-3.1-2.28-7.55-1.46-9.1 1.62-1.63 3.22.03 6.8 4.28 8.32h-8.6A3.45 3.45 0 0 0 5 20.76v5.12h17.02v-8.26c-.68-3.95-1.78-6.9-3.47-8.15-1.72-1.27-3.47-.8-4.12.49-.7 1.39.34 2.91 2.72 3.77 1.64.59 3.11.7 3.86.64a29.1 29.1 0 0 0-.86-2.62c-.37-.96.1-2.04 1.06-2.41.96-.38 2.04.1 2.41 1.06.28.7.53 1.44.75 2.21.23-.77.48-1.51.75-2.21.38-.96 1.46-1.44 2.42-1.06.96.37 1.43 1.45 1.06 2.41-.35.88-.63 1.75-.86 2.62.75.06 2.22-.05 3.86-.64 2.38-.86 3.42-2.38 2.72-3.77-.65-1.29-2.4-1.76-4.12-.49-1.69 1.25-2.79 4.2-3.47 8.15v8.26H43v-5.12a3.45 3.45 0 0 0-3.45-3.45h-8.6c4.25-1.52 5.91-5.1 4.28-8.32-1.55-3.08-6-3.9-9.1-1.62-.72.53-1.3 1.21-1.76 1.98a6.03 6.03 0 0 0-2.5-1.98ZM9.42 29.6v7.3a4.1 4.1 0 0 0 4.1 4.1h8.5V29.6H9.42Zm17.3 0V41h7.76a4.1 4.1 0 0 0 4.1-4.1v-7.3H26.72Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default BonusCenter;
